import "./SearchBar.css"
import React from "react"

class SearchBar extends React.Component {
  state = {term: ""}

  onInputChangeHandler = (e) => {
    this.setState({term: e.target.value})
  }

  onFormSubmit = (e) => {
    e.preventDefault()

    this.props.onSubmit(this.state.term)
  }

  render() {
    return (
      <div className="search-bar ui segment">
        <form className="ui form" onSubmit={this.onFormSubmit}>
          <div className="field ">
            <label>
              <i class="arrow alternate circle right icon"></i>
              June's YouTube Video Search App
            </label>
            <input
              type="text"
              value={this.state.term}
              onChange={this.onInputChangeHandler}
            />
          </div>
        </form>
      </div>
    )
  }
}
export default SearchBar